
export function authHeader(state) {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));
    
    // console.log('user');
    // console.log(user);
    // console.log('user.token');

    if (user && user.token) {
        return "Bearer " + user.token;
    } else {
        return "";
    }
}